/**
 * SWAYM - Bottom Sticky Add to Cart Web Component
 */

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
      }

      connectedCallback() {
        this.initElements();
        this.initObserver();
        this.bindEvents();
        this.syncWithMainForm();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        document.body.classList.remove('sticky__cart', 'has-sticky-cart');
      }

      initElements() {
        this.variantSelect = this.querySelector('[data-sticky-variant-select]');
        this.qtyInput = this.querySelector('[data-sticky-qty-input]');
        this.qtyMinusBtn = this.querySelector('[data-sticky-qty-minus]');
        this.qtyPlusBtn = this.querySelector('[data-sticky-qty-plus]');
        this.formVariantInput = this.querySelector('[data-sticky-variant-id]');
        this.formQtyInput = this.querySelector('[data-sticky-hidden-qty]');
        this.priceElem = this.querySelector('[data-sticky-price]');
        this.comparePriceElem = this.querySelector('[data-sticky-compare-price]');
        this.imgElem = this.querySelector('[data-sticky-image]');
        this.submitBtn = this.querySelector('[data-sticky-submit]');
        this.submitBtnText = this.querySelector('[data-sticky-submit-text]');
        this.buyNowBtn = this.querySelector('[data-sticky-buy-now]');

        // Main section product form elements
        this.mainForm =
          document.querySelector('product-form form') ||
          document.querySelector('.product_buy_button_form form') ||
          document.querySelector('form[action*="/cart/add"]');

        this.mainQtyInput =
          document.querySelector('.product-form__quantity input[name="quantity"]') ||
          document.querySelector('input[name="quantity"]');

        this.mainAddToCartBtn =
          document.querySelector('.swaym-product-add-to-cart') ||
          document.querySelector('.product-form__submit') ||
          document.querySelector('button[name="add"]');

        this.mainBuyNowBtn = document.getElementById('flo-buy-now-button');
      }

      initObserver() {
        const target =
          document.querySelector('.swaym-product-form__row') ||
          document.querySelector('.swaym-product-add-to-cart') ||
          document.querySelector('product-form') ||
          document.querySelector('.product_buy_button_form');

        if (!target) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // Main add to cart section is visible -> slide down (hide)
                this.classList.remove('is-visible');
                document.body.classList.remove('sticky__cart', 'has-sticky-cart');
              } else {
                // Main add to cart section is not visible -> slide up (show)
                this.classList.add('is-visible');
                document.body.classList.add('sticky__cart', 'has-sticky-cart');
              }
            });
          },
          {
            threshold: 0,
            rootMargin: '0px',
          }
        );

        this.observer.observe(target);
      }

      bindEvents() {
        // Quantity minus
        if (this.qtyMinusBtn) {
          this.qtyMinusBtn.addEventListener('click', () => {
            let currentVal = parseInt(this.qtyInput.value, 10) || 1;
            if (currentVal > 1) {
              this.updateQuantity(currentVal - 1);
            }
          });
        }

        // Quantity plus
        if (this.qtyPlusBtn) {
          this.qtyPlusBtn.addEventListener('click', () => {
            let currentVal = parseInt(this.qtyInput.value, 10) || 1;
            this.updateQuantity(currentVal + 1);
          });
        }

        // Quantity input direct edit
        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', () => {
            let val = parseInt(this.qtyInput.value, 10);
            if (isNaN(val) || val < 1) val = 1;
            this.updateQuantity(val);
          });
        }

        // Variant selection in sticky bar
        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', (e) => {
            const selectedOption = e.target.options[e.target.selectedIndex];
            this.onStickyVariantChange(selectedOption);
          });
        }

        // Listen for main variant picker changes in document
        document.addEventListener('change', (e) => {
          if (
            e.target.name === 'id' ||
            e.target.closest('variant-radios') ||
            e.target.closest('variant-selects') ||
            e.target.closest('hooktheme-variant-picker')
          ) {
            setTimeout(() => this.syncFromMainForm(), 50);
          }
        });

        // Add to Cart action - sync and trigger main Add to Cart
        if (this.submitBtn) {
          this.submitBtn.addEventListener('click', (e) => {
            this.syncWithMainForm();
            const mainBtn = document.querySelector('.swaym-product-add-to-cart') || document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]:not([data-sticky-submit])');
            if (mainBtn && mainBtn !== this.submitBtn) {
              e.preventDefault();
              mainBtn.click();
            }
          });
        }

        // Buy It Now action - sync and trigger main Buy It Now
        if (this.buyNowBtn) {
          this.buyNowBtn.addEventListener('click', (e) => {
            this.syncWithMainForm();
            const mainFloBtn = document.getElementById('flo-buy-now-button');
            if (mainFloBtn) {
              e.preventDefault();
              mainFloBtn.click();
            } else if (typeof window.handleFloBuyNowBtn === 'function') {
              window.handleFloBuyNowBtn(e);
            } else {
              // Direct checkout fallback
              const variantId = this.formVariantInput ? this.formVariantInput.value : (this.variantSelect ? this.variantSelect.value : '');
              const qty = this.qtyInput ? this.qtyInput.value : 1;
              if (variantId) {
                window.location.href = `/cart/${variantId}:${qty}?checkout`;
              }
            }
          });
        }
      }

      getInventoryInfo() {
        let invMgmt = '';
        let invPolicy = '';
        let invQty = 999;
        let available = true;

        if (this.variantSelect && this.variantSelect.options.length > 0) {
          const option = this.variantSelect.options[this.variantSelect.selectedIndex];
          if (option) {
            invMgmt = option.getAttribute('data-inventory-management');
            invPolicy = option.getAttribute('data-inventory-policy');
            invQty = parseInt(option.getAttribute('data-inventory-quantity'), 10);
            available = option.getAttribute('data-available') === 'true';
          }
        } else {
          invMgmt = this.getAttribute('data-single-inventory-management');
          invPolicy = this.getAttribute('data-single-inventory-policy');
          invQty = parseInt(this.getAttribute('data-single-inventory-quantity'), 10);
          available = this.getAttribute('data-single-available') === 'true';

          const mainQtyWrapper = document.querySelector('[data-quantity-input]');
          if (mainQtyWrapper) {
            const track = mainQtyWrapper.getAttribute('data-track-inventory') === 'true';
            const max = parseInt(mainQtyWrapper.getAttribute('data-inventory-max'), 10);
            if (track) {
              invMgmt = 'shopify';
              invPolicy = 'deny';
              invQty = isNaN(max) ? 0 : max;
            }
          }
        }

        let trackInventory = false;
        let maxInventory = 999;
        if (invMgmt === 'shopify' && invPolicy === 'deny') {
          trackInventory = true;
          maxInventory = isNaN(invQty) ? 0 : invQty;
        }

        return { trackInventory, maxInventory, available };
      }

      updateQuantity(val) {
        const { trackInventory, maxInventory, available } = this.getInventoryInfo();

        if (!available || (trackInventory && maxInventory <= 0)) {
          val = 0;
          if (this.qtyInput) {
            this.qtyInput.value = 0;
            this.qtyInput.disabled = true;
          }
          if (this.formQtyInput) this.formQtyInput.value = 0;
          if (this.qtyMinusBtn) this.qtyMinusBtn.disabled = true;
          if (this.qtyPlusBtn) this.qtyPlusBtn.disabled = true;
          if (this.submitBtn) this.submitBtn.disabled = true;
          if (this.buyNowBtn) this.buyNowBtn.disabled = true;
          if (this.submitBtnText) this.submitBtnText.textContent = 'SOLD OUT';
          return;
        }

        if (trackInventory && maxInventory > 0) {
          if (val > maxInventory) val = maxInventory;
        }

        if (val < 1) val = 1;

        if (this.qtyInput) {
          this.qtyInput.disabled = false;
          this.qtyInput.value = val;
        }
        if (this.formQtyInput) this.formQtyInput.value = val;

        if (this.qtyMinusBtn) this.qtyMinusBtn.disabled = val <= 1;
        if (this.qtyPlusBtn) this.qtyPlusBtn.disabled = trackInventory && maxInventory > 0 && val >= maxInventory;

        if (this.submitBtn) this.submitBtn.disabled = false;
        if (this.buyNowBtn) this.buyNowBtn.disabled = false;
        if (this.submitBtnText) this.submitBtnText.textContent = 'ADD TO CART';

        const mainQtyInput = document.querySelector('.product-form__quantity input[name="quantity"]') || document.querySelector('input[name="quantity"]:not([data-sticky-qty-input])');
        if (mainQtyInput && mainQtyInput.value != val) {
          mainQtyInput.value = val;
          mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onStickyVariantChange(option) {
        if (!option) return;

        const variantId = option.value;
        const price = option.getAttribute('data-price');
        const comparePrice = option.getAttribute('data-compare-at-price');
        const available = option.getAttribute('data-available') === 'true';
        const imageSrc = option.getAttribute('data-image');

        if (this.formVariantInput) {
          this.formVariantInput.value = variantId;
        }

        if (this.priceElem && price) {
          this.priceElem.innerHTML = price;
        }

        if (this.comparePriceElem) {
          if (comparePrice) {
            this.comparePriceElem.innerHTML = comparePrice;
            this.comparePriceElem.style.display = 'inline';
          } else {
            this.comparePriceElem.style.display = 'none';
          }
        }

        if (this.imgElem && imageSrc) {
          this.imgElem.src = imageSrc;
        }

        let currentQty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;
        this.updateQuantity(currentQty);

        this.syncMainVariantSelector(variantId);
      }

      syncMainVariantSelector(variantId) {
        if (!variantId) return;

        const mainSelects = document.querySelectorAll('select[name="id"], .single-option-selector');
        mainSelects.forEach((select) => {
          if (select !== this.variantSelect) {
            const matchingOpt = Array.from(select.options).find((opt) => opt.value === variantId);
            if (matchingOpt) {
              select.value = variantId;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });

        const radioInputs = document.querySelectorAll('input[type="radio"][data-variant-id], input[type="radio"][value]');
        radioInputs.forEach((radio) => {
          if (radio.value === variantId || radio.getAttribute('data-variant-id') === variantId) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      syncFromMainForm() {
        const mainVariantIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (!mainVariantIdInput) return;

        const currentVariantId = mainVariantIdInput.value;
        if (this.variantSelect && this.variantSelect.value !== currentVariantId) {
          this.variantSelect.value = currentVariantId;
          const selectedOption = this.variantSelect.options[this.variantSelect.selectedIndex];
          if (selectedOption) {
            this.onStickyVariantChange(selectedOption);
          }
        } else {
          let currentQty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;
          this.updateQuantity(currentQty);
        }
      }

      syncWithMainForm() {
        const mainQtyInput = document.querySelector('.product-form__quantity input[name="quantity"]') || document.querySelector('input[name="quantity"]:not([data-sticky-qty-input])');
        if (mainQtyInput && this.qtyInput) {
          const val = parseInt(mainQtyInput.value, 10) || 1;
          this.updateQuantity(val);
        }
      }
    }
  );
}
